const Campaign = () =>
  import(
    /* webpackChunkName: "financial-discount-campaign" */ '@/pages/financial/discount/campaign/index.vue'
  )
const CreateCampaign = () =>
  import(
    /* webpackChunkName: "financial-discount-campaign" */ '@/pages/financial/discount/campaign/create.vue'
  )
const EditCampaign = () =>
  import(
    /* webpackChunkName: "financial-discount-campaign" */ '@/pages/financial/discount/campaign/edit.vue'
  )

export default {
  path: 'campaign',
  meta: {
    label: 'campaign',
    auth: 'campaign'
  },
  component: {
    name: 'Campaign',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialDiscountCampaign',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Campaign
    },
    {
      name: 'FinancialCreateDiscountCampaign',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCampaign
    },
    {
      name: 'FinancialEditDiscountCampaign',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCampaign,
      props: true
    }
  ]
}
